module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj48cGF0aCBkPSJNOSAzaDE2LjVMMzQgMTEuNVYzNWEyIDIgMCAwIDEtMiAySDlhMiAyIDAgMCAxLTItMlY1YTIgMiAwIDAgMSAyLTJ6IiBmaWxsPSIjRjA1OTJBIi8+PHBhdGggZD0iTTI1LjUgM3Y2LjVhMiAyIDAgMCAwIDIgMkgzNHoiIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iLjQ1Ii8+PHRleHQgeD0iMjAuNSIgeT0iMjkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZvbnQtZmFtaWx5PSJBcmlhbCxIZWx2ZXRpY2Esc2Fucy1zZXJpZiIgZm9udC13ZWlnaHQ9IjcwMCIgZm9udC1zaXplPSIxMSIgZmlsbD0iI2ZmZiI+UDwvdGV4dD48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/disk/ppt.svg
// module id = 1304
// module chunks = 8